<template>
  <div class="details-double">
      <img src="../../assets/images/integral/double_01.jpg" alt="">
      <img src="../../assets/images/integral/double_02.jpg" alt="">
      <img src="../../assets/images/integral/double_03.jpg" alt="">
      <img src="../../assets/images/integral/double_04.jpg" alt="">
      <img src="../../assets/images/integral/double_05.jpg" alt="">
      <img src="../../assets/images/integral/double_06.jpg" alt="">
      <img src="../../assets/images/integral/double_07.jpg" alt="">
      <a href="javascript:;" class="go-back" @click="goBack()"></a>
  </div>
</template>

<script>
export default {
  methods:{
     goBack() {       
        let pageName = this.$route.query.page;
        // console.log(pageName)
        if (pageName) {          
          history.go(-1);  
        }else{
          this.$router.push('/')
        } 
    }
  }
}
</script>

<style>

</style>